import { updateLinksAttributes } from '../utils.js';

export default function customSignupWidget() {
  const widgetName = 'customSignup';
  const widgetOpts = customSignupOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const emailSignup = $('.content .emailSignup');
      $widget.replaceWith(emailSignup);

      if (hasData) {
        createCustomSignUp(data.items);
      } else {
        $widget.remove();
        emailSignup.remove();
      }
    },
  });

  function createCustomSignUp(widgetData) {
    updateSignupFeature(widgetData, widgetName);
  }
}

function updateSignupFeature(data, idName) {
  const { Title, URL } = data?.[0] || {};
  const containerSectionClass = 'seo-container';

  const signupTitle = Title || '';
  const inputPlaceholder = 'Email Address';
  const ariaLabel = 'Sign up to the newsletter';
  const buttonLabel = 'Subscribe';

  const $signupElement = $(`.${containerSectionClass} .emailSignup`).length
    ? $(`.${containerSectionClass} .emailSignup`)
    : $('.content .emailSignup');

  if (!$signupElement.length) {
    return;
  }

  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
    </div>
    `);

  $signupElement.attr('id', idName);
  $signupElement.attr('role', 'form');
  $signupElement.attr('aria-label', ariaLabel);
  if (!$signupElement.find('.input-container').length) {
    $signupElement
      .find('.emailInputField, .emailInputSubmit')
      .wrapAll('<div class="input-container"></div>');
  }
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').attr('role', 'button').text(buttonLabel);

  if (URL) {
    $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>${buttonLabel}</a>`);
  }
}
